import React from "react";
import i18n from "../../../../i18n/i18n";
import AddItem from "../../../../common/components/shared/addItem/addItem";
import OrderForm from "../orderForm/orderForm";

export default class AddOrder extends React.Component {
    render() {
        return (
            <AddItem
                class="add-order"
                header={i18n.t("transportation.order.addOrder.header")}
                content={<OrderForm isUpdate={false}/>}
            />
        );
    }
}